/*
 * COPYRIGHT (c) 2022
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState } from 'react';
import { DataContextProvider } from '@forge/data-connector';
import IEnergyManagementProps from '../IEnergyManagementProps';
import { Card, Icon, Tab, Tooltip } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import EmaasEnergyUsageHOC from './EmaasEnergyUsageHOC/EmaasEnergyUsageHOC';
import '../../../scss/KPICardTheme.scss';
import '../EmaasEnergyUsage/EmaasEnergyUsageHOC/EmaasEnergyUsageHOC.scss';
import { withLocalization } from '../../../locales/withLocalization';

const EmaasEnergyUsageWidget = (props: IEnergyManagementProps) => {
  const { connectorConfig, bearerToken, requestContext, emaasContext } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  return (
    <DataContextProvider config={connectorConfig}>
      <EmaasEnergyUsageHOC
        requestContext={requestContext}
        bearerToken={bearerToken}
        emaasContext={emaasContext}
      />
    </DataContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(EmaasEnergyUsageWidget);
